import { render } from "./ExclusaoDeDados.vue?vue&type=template&id=1b79122e&scoped=true"
const script = {}

import "./ExclusaoDeDados.vue?vue&type=style&index=0&id=1b79122e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b79122e"]])

export default __exports__